import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TextField,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Divider,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Alert,
} from "@mui/material";
import Pagination from "@mui/material/Pagination"; // <-- Eklendi
import { categoryService } from "../services/categoryService";
import { getMarketPlaces } from "../redux/actions/marketplacesActions";
import {
  addBulk,
  fetchBulk,
} from "../redux/actions/bulkPriceTransactionAction";
import useAlert from "../hooks/useAlert";
import marketplacesService from "../services/marketplacesService";
import { getEcommercePlaces } from "../redux/actions/ecommercePlaceActions";

export const BatchProcesses = () => {
  // State'ler
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [batchSize, setBatchSize] = useState("");
  const [selectSearchTerm, setSelectSearchTerm] = useState("");
  const [selectParamValue, setSelectParamValue] = useState("");
  const [selectFixedPriceAction, setSelectFixedPriceAction] = useState("");
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [marketplaces, setMarketplaces] = useState([]);
  const [selectSearchMarket, setSelectSearchMarket] = useState("");
  const [selectedMarket, setSelectedMarket] = useState("");
  const [searchText, setsearchText] = useState("");
  const [bulkPrices, setBulkPrices] = useState([]);
  const [totalBulk, setTotalBulk] = useState(0);

  // Sayfalama için page state'i
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const dispatch = useDispatch();

  const { showErrorAlertMarketpleaceBrand, showSuccessAlertMarketpleaceBrand } =
    useAlert();

  // Kategorileri çek
  const fetchCategories = async () => {
    try {
      const fetchedCategories =
        await categoryService.getCategoriesApiForDropdown(
          token,
          1,
          selectSearchTerm,
          authUserId
        );
      setCategories(fetchedCategories.data?.data.data);
    } catch (error) {
      console.error("Kategoriler alınırken bir hata oluştu:", error);
    }
  };

  // Kategoriler ilk yüklendiğinde ve arama terimi değiştiğinde
  useEffect(() => {
    fetchCategories();
  }, [selectSearchTerm]);

  // Kategori seçimi
  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  // Aranacak kategori listesi
  const filteredCategories = categories?.filter
    ? categories.filter((category) =>
        category.name.toLowerCase().includes(selectSearchTerm.toLowerCase())
      )
    : [];

  // Pazaryerlerini filtreleme
  const filteredmarket = marketplaces?.filter
    ? marketplaces.filter((market) =>
        market.name.toLowerCase().includes(selectSearchMarket.toLowerCase())
      )
    : [];

  // Fiyat/yüzde input
  const handleBatchSizeChange = (event) => {
    setBatchSize(event.target.value);
  };

  const handleSelectParamChange = (event) => {
    setSelectParamValue(event.target.value);
  };

  const handleSelectFixedPriceActionChange = (event) => {
    setSelectFixedPriceAction(event.target.value);
  };

  // Sabit fiyat güncelleme
  const handleFixedPriceUpdate = async () => {
    if (selectFixedPriceAction !== true && selectFixedPriceAction !== false) {
      alert("İşlem Boş geçilemez");
      return;
    }
    if (batchSize === "") {
      alert("Tutar Boş geçilemez");
      return;
    }
    if (selectedCategory === "") {
      alert("Kategori Boş geçilemez");
      return;
    }
    if (selectedMarket === "") {
      alert("Market Boş geçilemez");
      return;
    }

    let sendData = {
      userId: authUserId,
      type: 1, // Rakam için
      plus: selectFixedPriceAction,
      figure: batchSize,
      categoryId: selectedCategory.id,
      MarketPlaceId:
        selectedMarket.type == "marketplace" ? selectedMarket.id : null,
      EcommercePlaceId:
        selectedMarket.type == "ecommerce" ? selectedMarket.id : null,
      ia: true,
    };

    try {
      await dispatch(addBulk(sendData, token));
      showSuccessAlertMarketpleaceBrand();
      getBulkPriceTransaction();
    } catch {
      showErrorAlertMarketpleaceBrand();
    }
  };

  // Yüzde fiyat güncelleme
  const handlePercentagePriceUpdate = async () => {
    if (selectFixedPriceAction !== true && selectFixedPriceAction !== false) {
      alert("İşlem Boş geçilemez");
      return;
    }
    if (batchSize === "") {
      alert("Tutar Boş geçilemez");
      return;
    }
    if (selectedCategory === "") {
      alert("Kategory Boş geçilemez");
      return;
    }
    if (selectedMarket === "") {
      alert("Market Boş geçilemez");
      return;
    }

    let sendData = {
      userId: authUserId,
      type: 0, // Yüzde için
      plus: selectFixedPriceAction,
      figure: batchSize,
      categoryId: selectedCategory.id,
      MarketPlaceId:
        selectedMarket.type == "marketplace" ? selectedMarket.id : null,
      EcommercePlaceId:
        selectedMarket.type == "ecommerce" ? selectedMarket.id : null,
      ia: true,
    };

    try {
      await dispatch(addBulk(sendData, token));
      showSuccessAlertMarketpleaceBrand();
      getBulkPriceTransaction();
    } catch {
      showErrorAlertMarketpleaceBrand();
    }
  };

  const handlemarketChange = (e) => {
    setSelectedMarket(e.target.value);
  };

  // Pazaryerlerini çek
  const getMarketPlace = async () => {
    try {
      const [marketRes, ecommerceRes] = await Promise.all([
        dispatch(getMarketPlaces(token)),
        dispatch(getEcommercePlaces(token)),
      ]);
      const combinedData = [
        ...marketRes.data.map((place) => ({ ...place, type: "marketplace" })),
        ...ecommerceRes.data.map((place) => ({ ...place, type: "ecommerce" })),
      ];
      setMarketplaces(combinedData);

      // const response = await dispatch(getMarketPlaces(token));
      // if (response.success) {
      //   setMarketplaces(response?.data);
      // }
    } catch (err) {
      console.log("Marketler getirilemedi", err);
    }
  };

  // Toplu işlem kayıtlarını çek
  const getBulkPriceTransaction = async () => {
    try {
      // API'ye page parametresi ile istekte bulunuyoruz
      const response = await dispatch(
        fetchBulk(authUserId, token, page, pageSize)
      );
      setTotalBulk(response.recordsTotal);
      setBulkPrices(response?.data);
    } catch (err) {
      console.log("Toplu işlemler getirilemedi", err);
    }
  };

  // İlk yüklemede pazaryerleri ve toplu işlem kayıtlarını getir
  useEffect(() => {
    getMarketPlace();
  }, []);

  // Sayfa her değiştiğinde toplu kayıtları tekrar getir
  useEffect(() => {
    getBulkPriceTransaction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  // Durumlar
  const stateMap = {
    0: "Oluşturuldu",
    1: "Devam Ediyor",
    2: "Tamamlandı",
    3: "Yeniden Başlatıldı",
    9: "Başarısız",
  };

  // Pagination için toplam sayfa sayısını hesaplıyoruz (her sayfada 10 kayıt)
  const totalPages = Math.ceil(totalBulk / 10);

  // MUI Pagination onChange handler
  const handleChangePage = (event, value) => {
    setPage(value);
  };
  return (
    <Box
      sx={{
        width: "100%",
        padding: { xs: 1, sm: 2, md: 3 },
        marginTop: { xs: 1, sm: 2, md: 3 },
      }}
    >
      <Box
        sx={{
          padding: { xs: 2, sm: 3, md: 4 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: { xs: 2, sm: 3, md: 4 },
          mb: { xs: 2, sm: 3 },
          ml: { xs: 0, sm: 1 },
          backgroundColor: "#F7F9FC",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: 4,
              height: { xs: 20, sm: 24 },
              backgroundColor: "#1F1B45",
              mr: 1,
            }}
          />
          <Typography
            variant="h6"
            sx={{
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              fontWeight: "bold",
              color: "#333",
              fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
            }}
          >
            Toplu İşlem Yönetimi
          </Typography>
        </Box>
      </Box>
      <Alert
        sx={{ mb: 2, fontSize: { xs: "0.875rem", sm: "1rem" } }}
        severity="info"
      >
        Yapılan işlemlerin sisteme yansıması işlem yoğunluğuna göre 24 saati
        bulabilir.
      </Alert>
      <Divider sx={{ marginBottom: 1 }} />

      {/* Kategori Seçimi */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: 2, sm: 3 },
          borderRadius: 2,
          boxShadow: 2,
        }}
      >
        <FormControl fullWidth sx={{ marginBottom: 2 }} size="small">
          <InputLabel>Kategori</InputLabel>
          <Select
            value={selectedCategory}
            onChange={handleCategoryChange}
            label="Kategori"
            sx={{
              "& .MuiSelect-select": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
            }}
          >
            <Box sx={{ padding: 1 }}>
              <TextField
                size="small"
                label="Arama"
                variant="outlined"
                fullWidth
                value={selectSearchTerm}
                onChange={(e) => setSelectSearchTerm(e.target.value)}
                placeholder="Kategori ara"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                  "& .MuiInputBase-input": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                }}
              />
            </Box>
            <Divider sx={{ my: 1 }} />
            {filteredCategories.map((category, index) => (
              <MenuItem
                key={index}
                value={category}
                sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
              >
                {category.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* Pazaryeri Seçimi */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: 2, sm: 3 },
          borderRadius: 2,
          boxShadow: 2,
          mt: 2,
        }}
      >
        <FormControl fullWidth sx={{ marginBottom: 2 }} size="small">
          <InputLabel>Pazaryeri</InputLabel>
          <Select
            value={selectedMarket}
            onChange={handlemarketChange}
            label="Pazaryerleri"
            sx={{
              "& .MuiSelect-select": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
            }}
          >
            <Box sx={{ padding: 1 }}>
              <TextField
                size="small"
                label="Arama"
                variant="outlined"
                fullWidth
                value={selectSearchMarket}
                onChange={(e) => setSelectSearchMarket(e.target.value)}
                placeholder="Pazaryeri ara"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                  "& .MuiInputBase-input": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                }}
              />
            </Box>
            <Divider sx={{ my: 1 }} />
            {filteredmarket.map((market, index) => (
              <MenuItem
                key={index}
                value={market}
                sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
              >
                {market.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 2, md: 3 },
          marginTop: 3,
        }}
      >
        {/* Sabit Fiyat Güncelleme */}
        <Box
          sx={{
            flex: 1,
            backgroundColor: "#fff",
            padding: { xs: 2, sm: 3 },
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              marginBottom: 2,
              fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
            }}
          >
            Fiyat Güncelle (Rakam)
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 1, sm: 2 },
              marginBottom: 2,
            }}
          >
            <TextField
              size="small"
              label="Rakam"
              variant="outlined"
              sx={{
                flex: 1,
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
              value={batchSize}
              onChange={handleBatchSizeChange}
            />
            <FormControl sx={{ flex: 1 }} size="small">
              <InputLabel>İşlem Seçin</InputLabel>
              <Select
                value={selectFixedPriceAction}
                onChange={handleSelectFixedPriceActionChange}
                label="İşlem Seçin"
                sx={{
                  "& .MuiSelect-select": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                }}
              >
                <MenuItem
                  value={true}
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Artır
                </MenuItem>
                <MenuItem
                  value={false}
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Azalt
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Button
            variant="contained"
            sx={{
              borderRadius: 3,
              marginTop: 2,
              width: "100%",
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.875rem", sm: "1rem" },
              padding: { xs: "8px 16px", sm: "10px 20px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "center",
              boxShadow: "0 4px 8px rgba(31, 27, 69, 0.3)",
              "&:hover": {
                backgroundColor: "#2C285A",
                boxShadow: "0 6px 12px rgba(31, 27, 69, 0.4)",
              },
            }}
            onClick={handleFixedPriceUpdate}
          >
            Fiyatları Güncelle (Rakam)
          </Button>
        </Box>

        {/* Yüzde Fiyat Güncelleme */}
        <Box
          sx={{
            flex: 1,
            backgroundColor: "#fff",
            padding: { xs: 2, sm: 3 },
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              marginBottom: 2,
              fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
            }}
          >
            Fiyat Güncelle (Yüzde)
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 1, sm: 2 },
              marginBottom: 2,
            }}
          >
            <TextField
              size="small"
              label="Yüzde"
              variant="outlined"
              sx={{
                flex: 1,
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
              value={batchSize}
              onChange={handleBatchSizeChange}
            />
            <FormControl sx={{ flex: 1 }} size="small">
              <InputLabel>İşlem Seçin</InputLabel>
              <Select
                value={selectFixedPriceAction}
                onChange={handleSelectFixedPriceActionChange}
                label="İşlem Seçin"
                sx={{
                  "& .MuiSelect-select": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                }}
              >
                <MenuItem
                  value={true}
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Artır
                </MenuItem>
                <MenuItem
                  value={false}
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Azalt
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Button
            variant="contained"
            sx={{
              marginTop: 2,
              width: "100%",
              borderRadius: 3,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.875rem", sm: "1rem" },
              padding: { xs: "8px 16px", sm: "10px 20px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "center",
              boxShadow: "0 4px 8px rgba(31, 27, 69, 0.3)",
              "&:hover": {
                backgroundColor: "#2C285A",
                boxShadow: "0 6px 12px rgba(31, 27, 69, 0.4)",
              },
            }}
            onClick={handlePercentagePriceUpdate}
          >
            Fiyatları Güncelle (Yüzde)
          </Button>
        </Box>
      </Box>

      {/* Toplu işlemler tablosu */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: 2, sm: 3 },
          borderRadius: 2,
          boxShadow: 2,
          marginTop: 3,
          overflowX: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: 2,
            fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
          }}
        >
          Toplu İşlemler
        </Typography>
        <TableContainer>
          <Table size="small" aria-label="bulk price table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                  <strong>ID</strong>
                </TableCell>
                <TableCell sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                  <strong>Kategori</strong>
                </TableCell>
                <TableCell sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                  <strong>Pazaryeri</strong>
                </TableCell>
                <TableCell sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                  <strong>Tip</strong>
                </TableCell>
                <TableCell sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                  <strong>Durum</strong>
                </TableCell>
                <TableCell sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                  <strong>İşlem</strong>
                </TableCell>
                <TableCell sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                  <strong>Oluşturma Tarihi</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bulkPrices.map((item) => (
                <TableRow key={item?.id}>
                  <TableCell
                    sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {item?.id}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {item?.category?.name || "-"}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {item?.marketPlace?.name != null
                      ? item?.marketPlace?.name
                      : item?.ecommercePlace?.name || "-"}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {item?.type === 0 ? "Yüzde" : "Rakam"}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {stateMap[item?.state] || "Bilinmeyen"}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {item?.plus === true ? "Arttır" : "Azalt"}
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    {new Date(item.createDate).toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination bileşeni */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: 2,
            "& .MuiPaginationItem-root": {
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              minWidth: { xs: "32px", sm: "40px" },
              height: { xs: "32px", sm: "40px" },
            },
          }}
        >
          <Pagination
            color="primary"
            count={totalPages}
            page={page}
            onChange={handleChangePage}
            size="medium"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BatchProcesses;
